import type { LegacyInventoryContractTransformer } from '@/features/Quotes/types';
import type { ContractStore } from '@/features/Sparten/pfe/useContractStore';

export const pfeInventoryContractTransformers: LegacyInventoryContractTransformer<ContractStore> =
  {
    pferde: (data) => {
      const horseData = data as Record<string, unknown>[];
      return horseData.filter((horse) => horse.name !== '');
    },
    reitbeteiligungen: (data) => {
      const ridersData = data as Record<string, unknown>[];
      return ridersData.filter((rider) => rider.name !== '');
    },
  };
